import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { updateProduct } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentProduct,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: currentProduct,
  });

  const onSubmit = async (data) => {
    try {
      const body = {
        product_id: currentProduct.product_id,
        product_name: data.product_name,
        hsn_code: data.hsn_code,
        gst_percent: data.gst_percent,
        updated_by: getSessionData("user_id"),
      };

      // Replace with your API endpoint
      const response = await updateProduct(body);
      if (response.statusCode === 200) {
        successToastify("Product updated successfully!");
        fetchData();
        setmodal_list(false);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error adding product:", error);
    }
  };

  return (
    <Modal
      isOpen={modal_list}
      toggle={() => {
        tog_list();
      }}
      centered
    >
      <ModalHeader
        className="bg-light p-3"
        toggle={() => {
          tog_list();
        }}
      >
        Edit Product
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              Product Name
            </label>
            <input
              type="text"
              id="productName"
              className="form-control"
              placeholder="Enter Product Name"
              {...register("product_name", {
                required: "Product Name is required",
              })}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              HSN Code
            </label>
            <input
              type="text"
              id="hsn_code"
              className="form-control"
              placeholder="Enter HSN Code"
              {...register("hsn_code", {
                required: "HSN Code is required",
              })}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="productName" className="form-label">
              GST Percent
            </label>
            <input
              type="text"
              id="gst_percent"
              className="form-control"
              placeholder="Enter GST Percent"
              {...register("gst_percent", {
                required: "GST Percent is required",
              })}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success" id="add-btn">
              Edit Product
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

// Add prop types for validation
ProductEdit.propTypes = {
  modal_list: PropTypes.bool.isRequired, // Indicates if the modal is open
  setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
  tog_list: PropTypes.func.isRequired, // Function to toggle the modal
  fetchData: PropTypes.func.isRequired, // Function to fetch updated product data
  currentProduct: PropTypes.shape({
    product_id: PropTypes.number.isRequired, // The product ID being edited
    product_name: PropTypes.string.isRequired, // The product name being edited
  }).isRequired, // Current product details must be provided
};

export default ProductEdit;
